import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App.js';
import './styles.css';

registerSW({ immediate: true });

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(<App />);
}
